<template>	
	<transition name="slide-fade">
		<div class="step step2 animated" v-show="STEP_COUNTER == number_slide && last_slide_show">

	        <h2>{{ data_item.title }}</h2>
	        	<div class="questions_block">
	        		<div 
		            class="question_item"
		            v-for="(item, key, index) in data_item.items"
		            
		            >
		              <label class="question-label">
		              <input 
		              :type="data_item.type"  
		              :name="data_item.name" 
		              id="3" 
		              class="kitchen-type_input" 
		              :value="item.value !=  'other' ? item.value : other_input"
		              @click="chooseValue(item)"
		              v-model=" item.value ===  'other' ? checkbox_status : ''  "
		              >
		              	<div class="question_content">
		                 <!-- <img src="../assets/kitchen/straight.jpg" alt=""> -->
			                <div class="input_name_block">
				                  <div v-if="item.value != 'other'" class="item_name">
				                  	{{ item.title }}
				              	  </div>
				                  <input 
				                  @input = "changeInputBox(item)"
				                  ref="otherInput"
				                  v-if="item.value === 'other'" 
				                  v-model="other_input" 
				                  class="item_name__input" 
				                  value="" 
				                  placeholder="Другое... ( Введите )"
				                  >
				                  	
				                  </input>
				                  <span v-if="data_item.type ==='radio'" class="yellow_circle"></span>
				                  <svg v-if="data_item.type == 'checkbox'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect width="24" height="24" rx="4" fill="#39AFF3"/>
									<path d="M16.455 7.45498C16.6663 7.25381 16.9475 7.1426 17.2392 7.14481C17.531 7.14702 17.8104 7.26247 18.0187 7.46681C18.2269 7.67115 18.3476 7.9484 18.3553 8.24004C18.363 8.53169 18.2571 8.81492 18.06 9.02998L12.075 16.515C11.9721 16.6258 11.8479 16.7148 11.7098 16.7765C11.5717 16.8383 11.4226 16.8715 11.2714 16.8743C11.1201 16.8771 10.9699 16.8494 10.8296 16.7928C10.6894 16.7362 10.5619 16.6519 10.455 16.545L6.48599 12.576C6.37546 12.473 6.28681 12.3488 6.22532 12.2108C6.16383 12.0728 6.13077 11.9238 6.1281 11.7728C6.12544 11.6217 6.15323 11.4717 6.20981 11.3316C6.26639 11.1915 6.35061 11.0643 6.45743 10.9574C6.56426 10.8506 6.69151 10.7664 6.8316 10.7098C6.97168 10.6532 7.12172 10.6254 7.27278 10.6281C7.42383 10.6308 7.5728 10.6638 7.7108 10.7253C7.8488 10.7868 7.973 10.8754 8.07599 10.986L11.217 14.1255L16.4265 7.48798C16.4359 7.47643 16.4459 7.46541 16.4565 7.45498H16.455Z" fill="white"/>
								</svg>
			                </div>
		               	</div>
		              </label>
		            </div>
	        	</div>
	            
	              
	    </div>
	</transition>
	
</template>

<style lang="scss">	
	.item_name__input {
		outline: none;
		border:  none;
		font-size: 1.6rem;
	}
	.question {
		&-block {
			display: flex;
			flex-wrap:wrap;
		}
		&_item {
			&:nth-child(2n) {
				margin-right: 0;
			}
		}
	}
</style>

<script>	
	import { mapGetters } from 'vuex'

	export default {
		props: {
			'index': {
		        default: 1
		    },
		    'data_item': {
		    	default: []
		    },
		    last_slide_show: {
		    	defaults: true
		    }
		},
		data: function() {
			return {
				number_slide: this.index,
				other_input: '',
				other_input_focused: false,
				checkbox_status: false,
				choosed_array: []
			}
		},
		computed: {
			...mapGetters(['STEP_COUNTER', 'DATAMAIN']),
			checkChoosed() {
				console.log('gavno 2')
				if ( this.choosed_array.length > 0 ) {

					console.log('gavno')
					this.$emit('emitchoose', { choosen: true})
				}
			},
			// checkOtherInput() {
			// 	if ( this.other_input ) {
			// 		console.log(this.other_input)
			// 	}
			// }
		},
		watch: {
			// other_input: function() {
			// 	if ( this.choosed_array.some(elem => elem.value === 'other') && this.other_input ) {
			// 		this.$emit('unblocknextstep')
			// 	}
			// 	else {
			// 		this.$emit('blocknextstep')
			// 	}

			// 	if ( this.other_input.length > 0 ) {
			// 		this.checkbox_status = true
			// 	}
			// 	else {
			// 		this.checkbox_status = false
			// 	}
			// }
		},
		methods: {
			chooseValue(item) {
				console.log(item)
				if ( this.data_item.type === "checkbox" ) {

					if ( this.choosed_array.includes(item)) {
						let pos = this.choosed_array.indexOf(item)
						this.choosed_array.splice(pos,1)
	
					}

					else {
						this.choosed_array.push(item)
					}
					
				}

				if (  this.data_item.type === "radio") {
					this.choosed_array = item
					
				}

				if ( item.value === "other" ) {
					console.log(this.$refs.otherInput)
					
					if ( this.choosed_array.some(elem => elem.value === 'other') ) {
						this.$refs.otherInput[0].focus();
					}
					else {
						this.$refs.otherInput[0].blur();
					}
				}

				// Проверка на наличие в коризне 

				if ( this.choosed_array.length == 0 ) {
					console.log('block in component')
					this.$emit('blocknextstep')
					
				}
				else {	
					// var varwithother = this.choosed_array.filter(function(el) {
					//     return el.value === 'other'
					// }
					
					// console.log(`блок с неизвестным value = ${varwithother} `)
					if ( this.data_item.type === "checkbox" ) {
						if ( this.choosed_array.some(elem => elem.value === 'other') ) {
							console.log('Есть элемент с неизвестным')
							if ( this.other_input.length > 0 ) {
								this.$emit('unblocknextstep')
							}
							else {
								this.$emit('blocknextstep')
							}
						}
						else {
							this.$emit('unblocknextstep')
						}
					}
					else {
						this.$emit('unblocknextstep')
					}
					
					// this.$emit('unblocknextstep')
				}
			},
			changeInputBox(item) {
				if ( this.choosed_array.some(elem => elem.value === 'other') && this.other_input ) {
					this.$emit('unblocknextstep')
				}
				else {
					this.$emit('blocknextstep')
				}

				if ( this.other_input.length > 0 ) {
					this.checkbox_status = true


					if ( this.choosed_array.includes(item) ) {
						return
					}
					else {
						this.choosed_array.push(item)
					}
					
				}
				else {
					this.checkbox_status = false

					if ( this.choosed_array.includes(item) ) {
						let numInArr = this.choosed_array.indexOf(item)
						this.choosed_array.splice(numInArr,1)
					}
					else {
						return
					}
				}
			}
		}
	}
</script>